// =============================================================================
// FILE: src/components/ui/LoadingScreen.jsx
// MODULE: UI — Loading Screen
// PROJECT: Arcus Sports Management
//
// DESCRIPTION:
//   Full-page loading screen shown during the initial session check and
//   during route-level code splitting loads. Prevents flash of wrong content.
//   Matches the Arcus brand — clean, minimal, no animated logo.
// =============================================================================

/**
 * LoadingScreen
 * Full-viewport centered spinner with optional message.
 *
 * @param {string} [message] - Optional loading message below the spinner
 */
export function LoadingScreen({ message = 'Loading...' }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-950"
      role="status"
      aria-label={message}
    >
      {/* Arcus wordmark — small, not a full logo */}
      <span className="text-arcus-400 font-medium text-xl tracking-tight mb-8 select-none">
        Arcus
      </span>

      {/* Spinner */}
      <div className="relative w-10 h-10">
        <div className="absolute inset-0 rounded-full border-2 border-gray-200 dark:border-gray-800" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-arcus-400 animate-spin" />
      </div>

      {/* Message */}
      {message && (
        <p className="mt-4 text-sm text-gray-400 dark:text-gray-600">
          {message}
        </p>
      )}
    </div>
  )
}
